import React, { Component } from "react";
import DataTable from "react-data-table-component";
import Titulo from "../../../generico/TituloPagina";
import Popup from "react-popup";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import HabilitarCuentasService from "../../../../services/autogestion/HabilitarCuentasService";
import { trackPromise } from "react-promise-tracker";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import DatosSocio from "../../../generico/DatosSocio"
import AuthService from "../../../../services/login/auth.service";
import Sucursales from "../sucursales/Sucursales";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import SucursalesService from "../../../../services/autogestion/SucursalesService";

const paginationOptions = {
  rowsPerPageText: "Filas por página",
  rangeSeparatorText: "de",
  selectAllRowsItem: true,
  selectAllRowsItemText: "Todos",
};

export default class HabilitarCuenta extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.selectorValue = this.selectorValue.bind(this);
    this.obtenerDatos = this.obtenerDatos.bind(this);
    this.obtenerListadoCuentasAhorro = this.obtenerListadoCuentasAhorro.bind(
      this
    );
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  componentDidMount() {
   this.initData();
  }

  initData = () => {
    this.resetState();
    this.obtenerListadoCuentasAhorro();
  };

  resetState = () => {
    this.setState(this.getInitialState());
  };

  getInitialState = () => ({
    listaCuentas: [],
    tipoMoneda: null,
    sucursal: null, // o el valor por defecto de sucursal
    sucursalSeleccionada: null, // para guardar el objeto seleccionado
    disableSave: true

  });

  obtenerListadoCuentasAhorro = () => {
    trackPromise(
      HabilitarCuentasService.obtenerListadoCuentasAhorro().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          var items = jData.datos;
          for (var i = 0; i < items.length; i++) {
            respuesta.push({
              id: items[i].idAhorro,
              cuenta: items[i].idAhorro,
              saldo:
                formatoSeparadorMilesValue(items[i].saldoTotal) +
                " " +
                items[i].idMoneda +
                ".",
              descripcion: items[i].descripcion,
            });
          }
        }
        this.setState({ listaCuentas: respuesta });
      })
    ).catch(function (error) {
      console.log(error);
    });
  };

  popupConfirmacion() {
    Popup.create({
      title: "Apertura de Cuenta",
      content:
        "¿Desea realizar la apertura de cuenta de ahorro en " + this.state.tipoMoneda + "?",
      buttons: {
        right: [
          {
            text: "Cancelar",
            className: "secundary",
            action: () => { Popup.close(); }
          },
          {
            text: "Aceptar",
            className: "success",
            action: () => {
              var idMoneda = this.state.tipoMoneda === "Dólares" ? "U$S" : "GS";
              var sucursalSeleccionada = this.state.sucursalSeleccionada;
              //console.log(idMoneda);
              trackPromise(
                HabilitarCuentasService.aperturaCuentaAhorro(idMoneda, this.state.sucursal).then(
                  (response) => {
                    var data = JSON.stringify(response.data);
                    var jData = JSON.parse(data);
                    //console.log(jData);
                    if (jData.codigo === 0) {
                      mensajeExito(
                        "La Cuenta Nro. " +
                        jData.datos.idAhorro +
                        " fue Habilitada"
                      );
                      Popup.close();
                      Popup.queue(
                        this.notifiPopupDescargarComprobante(
                          "Comprobante",
                          "Cuenta Nro. " + jData.datos.idAhorro,
                          jData.datos,
                          jData.datos.idAhorro,
                          idMoneda,
                          sucursalSeleccionada
                        )
                      );
                      this.setState({disableSave: true, sucursal:null,sucursalSeleccionada:null});
                                          
                      this.obtenerListadoCuentasAhorro();
                    } else {

                      Popup.close();
                      Popup.queue(this.notifiPopup("Error", jData.mensaje));
                    }
                  }
                )
              );
            },
          }
        ],
      },
    });
  }

  notifiPopupDescargarComprobante = (titulo, mensaje, nroOperacion, cuenta, moneda,sucursalSeleccionada) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Bajar PDF",
            className: "success",
            action: function () {
              HabilitarCuentasService.descagarComprobante(
                "APERTURA DE CAJA DE AHORRO",
                nroOperacion,
                AuthService.getSocio().nombreCompleto,
                AuthService.getSocio().numeroSocio,
                cuenta,
                "INDIVIDUAL",
                "A LA VISTA",
                moneda,
                sucursalSeleccionada
              )
                .then((response) => {
                  var fileURL = URL.createObjectURL(response.data);
                  window.open(fileURL, "");
                })
                .catch(function (error) {
                  console.log(error);
                })
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerColumas() {
    return [
      {
        name: "Cuenta",
        selector: row => row.cuenta,
      },
      {
        name: "Descripción",
        selector: row => row.descripcion,
      },
      {
        name: "Saldo",
        selector: row => row.saldo,
        right: true,
      },
    ];
  }

  obtenerDatos() {
    const { listaCuentas } = this.state;
    return listaCuentas;
  }

  loadDatosSocio = () => {
    if (this.state.optionsCuentas != undefined)
      return this.state.optionsCuentas
    else {
      return this.getSucursales()
    }
  }

  getSucursales() {
    var options = [];
    trackPromise(
      SucursalesService.obtenerSucursales()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              options.push({
                value: jsonData.datos[i].codigo,
                label:
                  jsonData.datos[i].descripcion
              });
            }
            this.setState({ cuentasOrigen: jsonData.datos, optionsCuentas: options, sucursal: undefined });
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
    return options;
  }

  selectorValue(valor, objetoSeleccionado) {
    this.setState({disableSave: true});
    if(valor!==null && valor!==undefined){
      this.setState({disableSave: false});
    }
    this.setState({
      sucursal: valor, // normalmente sería el value, por ejemplo "SUC001"
      sucursalSeleccionada: objetoSeleccionado.label // el objeto completo { value, label }
    });
  }

  render() {
    if (this.state.debitos === undefined)

      var sucursales = this.loadDatosSocio();

    return (
      <div className="content-wrapper">
        <Titulo texto="Apertura de Cuentas de Ahorros" />
        <section className="content">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <div className="col-md-10" style={{ margin: "auto" }}>
                      <div className="row">
                        <div className="col-md-6 col-12">
                          <button className="button-habilitar " onClick={() => { this.setState({ tipoMoneda: 'Guaraníes' }); }} >
                            <div className="info-box cuenta-nueva-guaranies" data-toggle="collapse" data-target="#collapse" aria-expanded={this.state.expandir} aria-controls="collapse">
                              <span className="info-box-icon">
                                <img src="./dist/img/guarani-icon.png" style={{ width: "80%" }}></img>
                              </span>
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  Apertura de Cuenta
                                </span>
                                <h3 className="info-box-number">Guaraníes</h3>
                              </div>
                            </div>
                          </button>
                        </div>
                        <div className="col-md-6 col-12">

                          <button
                            className="button-habilitar"
                            onClick={() => { this.setState({ tipoMoneda: 'Dólares' }); }}
                          >
                            <div className="info-box cuenta-nueva-guaranies" data-toggle="collapse" data-target="#collapse" aria-expanded={this.state.expandir} aria-controls="collapse">
                              <span className="info-box-icon">
                                <img src="./dist/img/dolar-icono.png" style={{ width: "80%" }}></img>
                              </span>
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  Apertura de Cuenta
                                </span>
                                <h3 className="info-box-number">Dólares</h3>
                              </div>
                            </div>
                          </button>

                        </div>

                        <br />
                        <div className="col-md-12">
                          <div className="collapse" id="collapse">
                            
                            <div className="card card-sucursal">
                              <div className="card-body">
                                <div className="row">

                                  <div className="col-lg-6 col-md-7">

                                    {<Sucursales titulo="Seleccione una sucursal" ref="cuenta" presentacion="SELECT" selectorValue={this.selectorValue.bind(this)} itemSelected={this.state.sucursal} cuentas={sucursales} />}

                                  </div>
                                  <div className="col-lg-6 col-md-5" style={{ display: "grid", alignItems: "center" }}>
                                    <button disabled={this.state.disableSave} className="btn btn-cu-primary" onClick={() => this.popupConfirmacion("Guaranies")}  ><FontAwesomeIcon icon={faFloppyDisk} /> Guardar</button>

                                  </div>
                                </div>
                                <hr />
                                <div className="row">

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <DataTable
                          columns={this.obtenerColumas()}
                          data={this.obtenerDatos()}
                          noHeader={true}
                          dense={true}
                          pagination={true}
                          paginationComponentOptions={paginationOptions}
                          striped={true}
                          noDataComponent="no hay registros para mostrar"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
